import * as React from "react";
const myVar2 = require("../../../../assets/videos/finalvideo.mp4");

interface AboveFoldMainCompProps {}

export const AboveFoldMainComp: React.FunctionComponent<
  AboveFoldMainCompProps
> = (props) => {
  // const navigate = useNavigate();
  // const closeModal = () => {
  //   (document.querySelector('button[id="closeModal"]') as any).click();
  // };

  const [muted, setMuted] = React.useState(true);
  const handleToggleMute = () => setMuted((current) => !current);
  return (
    <>
      <div className="banner ">
        <div className="controller__video p-relative">
          <img
            src="https://ddappcdn.techxr.co/techxrWeb/home/thumbnail-main-slider.jpg"
            alt=""
            className="slidertopThumb"
          />
          <video autoPlay loop id="myVideo" muted={muted}>
            <source src={myVar2} />
          </video>
          <div className="common-container">
            <button onClick={handleToggleMute} className="controlButton">
              <img
                src={
                  muted
                    ? "https://ddappcdn.techxr.co/techxrWeb/home/mute-icon1.png"
                    : "https://ddappcdn.techxr.co/techxrWeb/home/unmute-icon1.png"
                }
                alt=""
              />
            </button>
          </div>
        </div>
        <div className="border-box">
          <div className="banner-box-top">
            <div className="banner-box-top-text">
              <div className="h1_head">
                Augmented &{" "}
                <h1>Virtual Reality, Made Accessible</h1>
                <br /> by TechXR Innovations
              </div>
            </div>
          </div>
          <div className="banner-box-border"></div>
        </div>
      </div>
    </>
  );
};
